import Log from './log'
export default Log



// WEBPACK FOOTER //
// ./src/plugins/log/index.js